import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {ScheduleTemplateModel, ScheduleType} from '../../../../projects/api/src/template/template.model';
import {SemRestRequestService} from '../../../../projects/api/src/sem-rest-request/sem-rest-request.service';
import {ApiList} from '../../API/api-list.enum';
import {TranslateService} from '@ngx-translate/core';
import {ContrDeviceParam} from '../../../../projects/api/src/contr-device-param/contrdeviceparam.model';
import {ObjectModel} from '../../../../projects/api/src/object/object.model';
import {ObjectsApiService} from '../../../../projects/api/src/object/objects-api.service';
import {ScheduleTemplatePeriodModel} from '../../../../projects/api/src/scheduletemplate/scheduletemplate.model';
import {InsparkMessageService} from '@inspark/inspark-components';
import {ScheduleTemplateApiService} from '../../../../projects/api/src/scheduletemplate/scheduletemplate-api.service';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-schedule-template-panel-edit',
    templateUrl: './schedule-template-panel-edit.component.html',
    styleUrls: ['./schedule-template-panel-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ScheduleTemplatePanelEditComponent implements OnInit {
  @Input() objects: ObjectModel[];
  @Input() showMenu = true;
  @Input() configPrefix: string = '';
  @Input() dailySchedule: ScheduleTemplatePeriodModel;
  @Input() referenceData;
  @Input() editableData: ScheduleTemplateModel;
  @Input() saveComplete;
  @Input() create;
  @Input() stateParams;
  @Input() loadByCdpId;
  @Input() isModal = false;
  @Output() changeObject = new EventEmitter<{ objectId: number; date?: Date } | null>();

  public ingredient;
  public currentObject: null | { objectId: number; date?: Date } = null;
  public isAllowScroll = true;
  public isCustom = false;
  public showWarningWhenCDPNotLoad = false;
  public loading = false;
  buttonLabels = {create: 'CREATE', save: 'SAVE', addInterval: 'ADD INTERVAL', toTypicalSchedule: 'TO TYPICAL SCHEDULE', close: 'CLOSE'};
  contrdeviceparamid;
  editableDataJson: string;
  titleSave = 'Fill the form';


  isMobile = !this.deviceService.isDesktop();

  constructor(private request: SemRestRequestService,
              private objectsApi: ObjectsApiService,
              private scheduletemplateApi: ScheduleTemplateApiService,
              private translate: TranslateService,
              private cdr: ChangeDetectorRef,
              private messageService: InsparkMessageService,
              private deviceService: DeviceDetectorService
  ) {
  }

  ngOnInit() {
    this.editableDataJson = JSON.stringify(this.editableData);


    if (this.objects && this.objects.length === 1) {
      this.currentObject = {objectId: this.objects[0].id};
      this.changeObject.emit(this.currentObject);
    }

    if (this.loadByCdpId) {
      this.loading = true;
      this.request
        .baseUrlAppend(ApiList.Db, ApiList.ContrDeviceParam, this.loadByCdpId)
        .getSingle<ContrDeviceParam>()
        .subscribe((cdp: ContrDeviceParam) => {
          this.loading = false;
          if (cdp.paramon === null) {
            /* SEM-4906 Создавать Инд. расписание без учета ТК */
            this.showWarningWhenCDPNotLoad = false;
            this.isCustom = true;
            this.editableData.name = '';
            this.contrdeviceparamid = cdp.id;
            this.cdr.detectChanges();
            return;
          }
          this.editableData = cdp.paramon.template;
          this.contrdeviceparamid = cdp.id;
          this.isCustom = cdp.paramon.schedule.individual;
          if (!this.isCustom) {
            this.editableData.name = 'Индивидуально: ' + this.editableData.name;
          }
          this.cdr.detectChanges();
        });
    } else {
      this.contrdeviceparamid = this.contrdeviceparamid || -1;
      if (this.contrdeviceparamid >= 0) {
        const cdp = this.referenceData.contrdeviceparam.find(item => item.id === this.contrdeviceparamid);
        try {
          this.isCustom = cdp.paramon.schedule.individual;
          if (!this.isCustom) {
            this.editableData.name = 'Индивидуально: ' + this.editableData.name;
          }
        } catch (e) {
        }
      }
    }

    if (!this.editableData) {
      this.editableData = {
        mode: 'UNION',
        name: '',
        comment: '',
        planningareas: []
      };
    }
    this.cdr.detectChanges();
  }

  @HostListener('wheel', ['$event'])
  handleWheelEvent(event) {
    if (this.isAllowScroll) {
      return;
    }
    event.preventDefault();
  }

  /**
   * Добавляет интервал работы устройства/правила
   */
  public addPlaningArea(scheduletype: ScheduleType = 'DAILY') {
    this.editableData.planningareas = [...this.editableData.planningareas,
      {
        scheduletype: scheduletype,
        timeranges: [{
          leftbound: 0,
          rightbound: 0,
          bindingtype: 'BOTH_BORDERS',
          activesubrange: 0,
          passivesubrange: 0,
        }],
        planningdates: [],
      }
    ];
  }

  /**
   * Удаляет интервал работы устройства/правила
   */
  public removePlaningArea(id: number) {
    this.editableData.planningareas = this.editableData.planningareas.filter((_el, index) => index !== id);
  }

  /**
   * Сохраняет или создает новый шаблон расписаний
   */
  public save() {
    this.request.baseUrlAppend(ApiList.Db, ApiList.Scheduletemplate);
    const triggerWhenSaveDone = (data) => {
      this.saveComplete(data);
      this.changeObject.emit(this.currentObject);
      this.messageService.success(this.translate.instant('Item successfully saved'));
      this.editableDataJson = JSON.stringify(this.editableData);


    };

    this.editableData.planningareas.forEach(_planningarea => {
      if (_planningarea.scheduletype === 'DAILY') {
        _planningarea.timeranges.forEach(timerange => timerange.bindingtype = 'LEFT_BORDER');
      }
    });

    if (!this.editableData.id) {
      this.request.postFormData(this.editableData).subscribe((data) => {
        triggerWhenSaveDone(data);
        this.scheduletemplateApi.sendAction({
          name: 'create',
          data
        });
      });
    } else {
      this.request.updateById(this.editableData.id, this.editableData).subscribe(triggerWhenSaveDone.bind(this));

    }
  }

  /**
   * Сохраняет кастомное расписание
   */
  public saveCustom() {
    if (!confirm(this.translate.instant('Do you want save individual schedule?'))) {
      return;
    }

    this.request.baseUrlAppend(ApiList.Db, ApiList.ContrDeviceParam, this.contrdeviceparamid, ApiList.Schedule);
    const triggerWhenSaveDone = () => {
      this.saveComplete();
      this.messageService.success(this.translate.instant('Item successfully saved'));
    };

    this.editableData.planningareas.forEach(_planningarea => {
      if (_planningarea.scheduletype === 'DAILY') {
        _planningarea.timeranges.forEach(timerange => timerange.bindingtype = 'LEFT_BORDER');
      }
    });

    this.request.postFormData(this.editableData).subscribe(triggerWhenSaveDone.bind(this));
  }

  /**
   * Сохраняет кастомное расписание
   */
  public deleteCustom() {
    if (!confirm(this.translate.instant('Do you want delete individual schedule?'))) {
      return;
    }
    this.request.baseUrlAppend(ApiList.Db, ApiList.ContrDeviceParam, this.contrdeviceparamid, ApiList.Schedule);
    const triggerWhenDeleteDone = () => {
      this.saveComplete();
      this.messageService.success(this.translate.instant('Item delete'));
    };

    this.editableData.planningareas.forEach(_planningarea => {
      if (_planningarea.scheduletype === 'DAILY') {
        _planningarea.timeranges.forEach(timerange => timerange.bindingtype = 'LEFT_BORDER');
      }
    });

    this.request.delete({}).subscribe(triggerWhenDeleteDone.bind(this));
  }

  /**
   * Выполняет валидацию формы
   */
  public validate() {
    if (!this.editableDataJson) {
      this.editableDataJson = JSON.stringify(this.editableData);
    }

    if (!(this.editableData.name.replace(/\s/g, '').length > 0)) {
      this.titleSave = 'Fill the form';
      return false;
    }
    if (!(this.editableData.planningareas.length > 0)) {
      this.titleSave = 'Fill the interval';
      return false;
    }

    const dataJson = JSON.parse(this.editableDataJson);
    if (this.editableData.id && dataJson.id) {
      if (this.editableData.id === dataJson.id) {
        const _compare = JSON.stringify(this.editableData);
        if (!this.editableDataJson.localeCompare(_compare)) {
          this.titleSave = 'Form not changed 1';
          return false;
        }
      } else {
        this.editableDataJson = JSON.stringify(this.editableData);
        return false;
      }
    } else if (!this.editableData.id && !dataJson.id) {
      const _compare = JSON.stringify(this.editableData);
      if (!this.editableDataJson.localeCompare(_compare)) {
        this.titleSave = 'Form not changed 2';
        return false;
      }
    }
    this.titleSave = '';
    return true;
  }

  allowScroll(state) {
    this.isAllowScroll = state;
  }

  public savePipe(): void {
    if (this.contrdeviceparamid < 0) {
      this.save();
      return;
    }

    if (this.contrdeviceparamid >= 0) {
      this.saveCustom();
      return;

    }
  }

  removePlaningDateRange(event: { paIndex: number; pdIndex: number }): void {
    const filteredPlaningDates = this.editableData
      .planningareas[event.paIndex]
      .planningdates.filter((_, index) => index !== event.pdIndex);
    this.editableData.planningareas[event.paIndex].planningdates = filteredPlaningDates;
    this.editableData.planningareas = [...this.editableData.planningareas];
  }

  addPlaningDateRange(event): void {
    this.editableData.planningareas[event].planningdates.push({datefrom: Date.now(), dateto: Date.now(), yearly: false});
    ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].forEach(key => this.editableData.planningareas[event][key] = false);
    this.editableData.planningareas = [...this.editableData.planningareas];
  }

  changeDays(event): void {
    let pa = this.editableData.planningareas[event.index];
    pa = {...pa, ...event.planingdates, planningdates: []};
    this.editableData.planningareas[event.index] = pa;
    this.editableData.planningareas = [...this.editableData.planningareas];
  }

  changeTimerange(event): void {
    const pa = this.editableData.planningareas[event.index];
    pa.timeranges[0] = {...pa.timeranges[0], ...event.timeranges};
    this.editableData.planningareas[event.index] = pa;
    this.editableData.planningareas = [...this.editableData.planningareas];
  }

  onChangeObject(event: { objectId: number; date?: Date }): void {
    this.currentObject = event;
    this.changeObject.emit(this.currentObject);
  }

  showValidationError(msg): void {
    this.messageService.error(msg);

  }

  private syncItems() {

  }
}
